import Head from 'next/head';
import {HT_INFO_UTILS, HT_INFO_SOCIAL} from '@constants/hellotech';

type SocialMetaTagsProps = {
  meta: {
    title: string;
    description: string;
  };
  image: string;
  pathname?: string;
  imageWidth?: string;
  imageHeight?: string;
};

const SocialMetaTags = ({sku}: {sku: SocialMetaTagsProps}) => {
  const {meta, pathname = '', image, imageWidth = '300', imageHeight = '250'} = sku || {};

  return (
    <Head>
      <meta name="twitter:title" content={meta.title || 'HelloTech'} />
      <meta name="twitter:description" content={meta.description || ''} />
      <meta name="twitter:image" content={image} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={`${HT_INFO_SOCIAL.facebook.og.url}${pathname}`} />
      <meta property="og:image" content={`${HT_INFO_UTILS.cdn}/public${image}`} />
      <meta property="og:image:url" content={`${HT_INFO_UTILS.cdn}/public${image}`} />
      <meta property="og:image:width" content={imageWidth} />
      <meta property="og:image:height" content={imageHeight} />
    </Head>
  );
};

export default SocialMetaTags;
